import React, { Component } from "react";

export class FooterDashboard extends Component {

  render() {
    return (
      <div>
        <footer className="text-center mt-[-10px] mt-[32px]">
          <div className="text-gray-800 text-black text-center text-[14px] tracking-normal leading-[140%] p-4">
              Copyright ©2022
            <a className="text-gray-800 text-black text-center text-[14px] tracking-normal leading-[140%] ml-1" href="https://tailwind-elements.com/">Powered by Highr ID</a>
          </div>
        </footer>
      </div>
    );
  }
}
export default FooterDashboard;